module.exports = __webpack_public_path__ + "static/media/insure_explanation4.bbbb4481.png";